import { CanvasJSON, TRANSPARENT_PIXEL } from '@doer/frontend-components/creativity-editor';

// Pieces: `background` (Rect placeholder), `image-000` (image-replace cover), `quote` (autoFit), `author`.

const CANVAS = { width: 1080, height: 1350 };

// Horizontally centered (originX: 'center'); textbox grows upward from the
// bottom anchor as fontSize grows. Tweak `width` or `bottomMargin` freely —
// the absolute position is recomputed.
const QUOTE_BOX = {
  width: 950,
  bottomMargin: 145,
  maxHeight: 430
};

const AUTHOR_BOX = {
  top: 1230, // TODO(design)
  width: 600, // TODO(design)
  height: 70 // TODO(design)
};

const ESPN_LOGO_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/ESPN/logos/institucional-blanco.png`;

export const espnTextuales1080x1350: CanvasJSON = {
  version: '7.1.0',
  objects: [
    // White placeholder; covered by image-000 once an image is uploaded.
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1350,
      fill: '#ffffff',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // imageFit: 'cover' rescales the upload to fill 1080×1350.
    {
      pieceId: 'background-image',
      type: 'Image',
      imageFit: 'cover',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 675,
      width: 1080,
      height: 1350,
      scaleX: 1,
      scaleY: 1,
      cropX: 0,
      cropY: 0,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: []
    },

    {
      pieceId: 'logo',
      cropX: 0,
      cropY: 0,
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      imageFit: 'contain',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 120.855,
      top: 57.9392,
      width: 2430,
      height: 600,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0708,
      scaleY: 0.0708,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: ESPN_LOGO_URL,
      crossOrigin: null,
      filters: []
    },

    // Overlay
    {
      cropX: 0,
      cropY: 0,
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 675,
      width: 1080,
      height: 1350,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0002,
      scaleY: 1.0002,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/ESPN/ESPN-textuales/overlay-1080x1350.png`,
      crossOrigin: null,
      filters: []
    },

    {
      pieceId: 'quote',
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'bottom',
      left: CANVAS.width / 2,
      top: CANVAS.height - QUOTE_BOX.bottomMargin,
      width: QUOTE_BOX.width,
      fontSize: 96, // starting value, overwritten by autoFit
      fontFamily: 'ESPN Pro Loud',
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: 0.8,
      textAlign: 'center',
      fill: '#FFFFFF',
      stroke: null,
      strokeWidth: 0,
      opacity: 1,
      angle: 0,
      visible: true,
      skewX: -6,
      skewY: 0,
      text: '',
      autoFit: {
        minFontSize: 40,
        maxFontSize: 150,
        maxHeight: QUOTE_BOX.maxHeight,
        snapTo: 2
      }
    },

    // `wrapText` resizes this rect's width to match the `author` textbox + padding.
    {
      type: 'Rect',
      wrapText: { pieceId: 'author', paddingX: 30, minWidth: 200 },
      version: '7.1.0',
      originX: 'center',
      originY: 'top',
      left: CANVAS.width / 2,
      top: AUTHOR_BOX.top,
      width: AUTHOR_BOX.width,
      height: AUTHOR_BOX.height,
      fill: '#FFFFFF',
      stroke: null,
      strokeWidth: 0,
      opacity: 1,
      visible: true,
      skewX: -6,
      skewY: 0,
      selectable: false,
      evented: false
    },

    {
      pieceId: 'author',
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: CANVAS.width / 2,
      top: AUTHOR_BOX.top + AUTHOR_BOX.height / 2,
      width: AUTHOR_BOX.width - 40,
      fontSize: 36, // TODO(design)
      fontFamily: 'Playoff Pro Sans',
      fontWeight: 800,
      fontStyle: 'italic',
      lineHeight: 1,
      textAlign: 'center',
      fill: '#000000',
      opacity: 1,
      visible: true,
      text: ''
    }
  ],
  background: '#f0f0f0'
};
